import { useState, useEffect, useMemo } from "react";
// import { BillingScheduleRow } from "./types";

type YearlySchedule = {
  noOfYear: number;
  commercialBillingSchedule: any[];
};

export const useBillingSchedulePreview = (input?: YearlySchedule[]) => {
  // 1. Safe breakdown
  const breakdown: YearlySchedule[] = Array.isArray(input) ? input : [];

  // 2. Year options
  const yearOptions = useMemo(() => {
    return breakdown.map((item) => ({
      label: `Year ${item?.noOfYear ?? "-"}`,
      value: item?.noOfYear ?? 0,
    }));
  }, [breakdown]);

  // 3. Show dropdown flag
  const showYearOption = yearOptions.length > 1;

  // 4. Default year
  const defaultYear = breakdown.length > 0 && typeof breakdown[0]?.noOfYear === "number" ? breakdown[0].noOfYear : null;

  // 5. Get schedule safely
  const getScheduleByYear = (year?: number | null) => {
    if (!year) return [];

    const found = breakdown.find((item) => item?.noOfYear === year);

    if (!found || !Array.isArray(found.commercialBillingSchedule)) {
      return [];
    }

    return found.commercialBillingSchedule;
  };

  // 6. State (single source of truth)
  const [selectedYear, setSelectedYear] = useState<number | null>(1);
  const [selectedSchedule, setSelectedSchedule] = useState<any[]>([]);

  // 7. Initialize + sync when breakdown changes
  useEffect(() => {
    if (!breakdown.length) return;

    const initialYear = defaultYear ?? breakdown?.[0]?.noOfYear ?? null;

    setSelectedYear(initialYear);

    if (initialYear != null) {
      setSelectedSchedule(getScheduleByYear(initialYear));
    }
  }, [breakdown, defaultYear]);

  // 8. Year change handler (single place updates everything)
  const selectYear = (year: number | null) => {
    setSelectedYear(year);
    setSelectedSchedule(getScheduleByYear(year));
  };

  return {
    yearOptions,
    showYearOption,
    getScheduleByYear,
    defaultYear,
    hasData: breakdown.length > 0,

    // state
    selectedYear,
    selectedSchedule,

    // actions
    selectYear,
  };
};
